module.exports = __webpack_public_path__ + "img/spider-chart.290e9498.png";